// Tracks the active input device (keyboard vs gamepad) so the UI can show matching prompts.
// Input flips it: a keydown -> 'keyboard', any pad activity -> 'gamepad'. UI subscribes.

export type InputMode = 'keyboard' | 'gamepad';

let mode: InputMode = 'keyboard';
let xbox = false;
const subs = new Set<(m: InputMode) => void>();

export function getInputMode(): InputMode {
  return mode;
}

export function isXboxPad(): boolean {
  return xbox;
}

export function setInputMode(next: InputMode, isXbox = false): void {
  if (next === 'gamepad') xbox = isXbox;
  if (next === mode) return;
  mode = next;
  for (const cb of subs) cb(next);
}

/** Subscribe to mode changes. Returns an unsubscribe fn. */
export function onInputMode(cb: (m: InputMode) => void): () => void {
  subs.add(cb);
  return () => subs.delete(cb);
}

/** True if a gamepad id looks like an Xbox controller (Microsoft vendor 045e). */
export function looksXbox(id: string): boolean {
  return /xbox|045e/i.test(id);
}

// Controller buttons for the 8 abilities, in ABILITIES order. Xbox face-button colors.
export const PAD_ABILITY_LABELS: ReadonlyArray<{ label: string; color: string }> = [
  { label: 'A', color: '#6abf4b' },
  { label: 'B', color: '#e8503a' },
  { label: 'X', color: '#3a7ae8' },
  { label: 'Y', color: '#e8c93a' },
  { label: 'LB', color: '#9a93b0' },
  { label: 'RB', color: '#9a93b0' },
  { label: 'LT', color: '#9a93b0' },
  { label: 'RT', color: '#9a93b0' },
];
